import Vue from 'vue';
import billTransformer from './../../transformers/bill';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentBill', billTransformer.fetch(data));
  resolve(billTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(billTransformer.fetch(errors));
};

export default (id, roundInvoiceTotal) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/bills/${id}/updateRoundInvoiceTotal`, billTransformer.send({ roundInvoiceTotal }))
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/updateRoundInvoiceTotal.js